/* eslint-disable react/no-unknown-property */
import React from 'react';
import AgentLeaderboardItem, { AgentLeaderboardItemProps } from '../agent-leaderboard-item/AgentLeaderboardItem';
import * as styles from './TeamLeaderboardPosition.style';

export interface TeamLeaderboardPositionProps {
  teamLeaderboardItems: Omit<AgentLeaderboardItemProps, 'hightlighted' | 'size' | 'details'>[],
  preview?: boolean,
  previewLimit?: number,
}

export const TeamLeaderboardPosition: React.FC<TeamLeaderboardPositionProps> = ({
  teamLeaderboardItems,
  preview = false,
  previewLimit = 5,
}) => {
  const actualItems = React.useMemo(() => {
    if (preview) {
      return teamLeaderboardItems.slice(0, previewLimit);
    }
    return teamLeaderboardItems;
  }, [preview, previewLimit, teamLeaderboardItems]);

  if (!teamLeaderboardItems || teamLeaderboardItems.length === 0) {
    return null;
  }
  return (
    <div css={styles.basic}>
      {actualItems.map((item) => (
        <div key={item.name}>
          <AgentLeaderboardItem
            {...item}
            size="S"
          />
        </div>
      ))}
    </div>
  );
};

export default TeamLeaderboardPosition;
